import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconRadio = props => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="m10 5c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0-5c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" />
  </SvgIcon>
);

export default IconRadio;



// WEBPACK FOOTER //
// ./src/components/icons/IconRadio.js